class TsUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
  }

  async rerenderUpsell() {
    const sectionToRender = this.closest('.shopify-section')?.id;
    if (!sectionToRender) return;

    const currentUrl = window.location.href.split('?')[0];
    const sectionResponse = await fetch(`${currentUrl}?section=${sectionToRender}`);
    const sectionData = await sectionResponse.text();


    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sectionData;

    const newUpsell = tempDiv.querySelector('[data-upsell]');
    const oldUpsell = document.querySelector('[data-upsell]');

    if (newUpsell && oldUpsell) {
      oldUpsell.innerHTML = newUpsell.innerHTML;
    } else if (!newUpsell && oldUpsell) {
      oldUpsell.innerHTML = '';
    }
  }


  disconnectedCallback() {
  }
}

customElements.define('ts-upsell', TsUpsell);
